module.exports = __webpack_public_path__ + "static/media/logo.9ff01047.svg";